import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Category } from '@app/shared/interfaces/Category';
import { environment } from 'src/environments/environment';
import { AppConfigService } from './app-config.service';
@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  constructor(private http: HttpClient) {}

  GetAllGategories() {
    let endPoint = `${AppConfigService.settings.dataApiUrl}Category?expand=AttributeValues,ClonedCategories,Translations&$select=AttributeValues,Id,Name,ParentId,Position,ClonedCategories,Translations`;
    return this.http.get(endPoint);
  }

  GetGategory(categoryId: number) {
    let endPoint = `${AppConfigService.settings.dataApiUrl}Category?filter=id eq ${categoryId}&expand=AttributeValues,ProductCategories,ClonedCategories,Translations&$select=AttributeValues,Id,Name,ParentId,Position,type,ProductCategories,ClonedCategories,Translations`;
    return this.http.get(endPoint);
  }

  RemoveCategory(key: number) {
    let endPoint = `${AppConfigService.settings.dataApiUrl}Category`;
    return this.http.delete(endPoint + '/' + key);
  }
  AddNewCategory(category: Category) {
    let endPoint = `${AppConfigService.settings.dataApiUrl}Category`;
    return this.http.post(endPoint, category);
  }
  updateCategory(category: Category) {
    let endPoint = `${AppConfigService.settings.dataApiUrl}Category`;
    return this.http.put(endPoint + '/' + category.Id, category);
  }

  changeCategoryLevel(
    categoryId: number,
    previosPosition: number,
    parentId?: number
  ) {
    return this.http.get(
      `${
        AppConfigService.settings.apiUrl
      }CustomCategory/change-category-level/${categoryId}?previousPoition=${previosPosition}${
        parentId != null ? `&parentId=${parentId}` : ''
      }`
    );
  }

    selectAllCategoryProducts(categoryId:number) {
  return this.http.post<any>(
    `${AppConfigService.settings.apiUrl}CustomProduct/select-all-category-products?categoryId=${categoryId}`,
    {}
  );
}
  bulkDeleteCategoryProducts(categoryId: number, productIds: number[]) {
    const url = `${AppConfigService.settings.dataApiUrl}Category(${categoryId})/BulkDeleteCategoryProducts?key=${categoryId}`;
    return this.http.put(url, productIds);
  }
}
